import { useCallback, useSyncExternalStore } from "react";

/**
 * Reads a media query.
 *
 * `useSyncExternalStore` is the right tool here: matchMedia *is* an external
 * store. Mirroring it into `useState` through an effect, as this did before,
 * renders once with the wrong answer and then corrects itself.
 */
export function useMediaQuery(query) {
  const subscribe = useCallback(
    (onStoreChange) => {
      const media = window.matchMedia(query);
      media.addEventListener("change", onStoreChange);
      return () => media.removeEventListener("change", onStoreChange);
    },
    [query],
  );

  const getSnapshot = useCallback(() => window.matchMedia(query).matches, [query]);

  // Server render has no viewport; assume the larger layout.
  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}
